<template>
<div class="chapter">
<div class="inner_page">
<div class="bg0">
<h1 class="tit"><a id="page_1"></a>250 Continuous-Line Quilting Designs</h1>
</div>
<div class="bgt">
<p class="tit1">for Hand, Machine &amp; Long-Arm Quilters</p>
<p class="aut">Laura Lee Fritz</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 01_Title.vue?b3a18aca